<template>
  <PopUp :show="modal" @hideModal="hideModal">
    <div class="publications">
      <header class="publications__header">
        <h3 class="publications__header_title">Reorder {{ orderType }}</h3>
        <div class="publications__header_actions">
          <BaseButton
            class="button--sm button--green button--uppercase"
            text="Save Changes"
            :loading="loading"
            :disabled="!changed"
            @click="$emit('reorder', orderedItems)"
          ></BaseButton>
        </div>
      </header>
      <draggable
        class="publications__body"
        v-model="orderedItems"
        group="publications"
        @start="drag = true"
        @end="drag = false"
        @change="changeOrder"
      >
        <div v-for="element in orderedItems" :key="element.id" class="publications__body_item">
          <p>
            {{ element.title }}
          </p>
          <IconMoveDots class="publications__body_item_svg"></IconMoveDots>
        </div>
      </draggable>
    </div>
  </PopUp>
</template>
<script>
import draggable from "vuedraggable";
import PopUp from "@/components/PopUp.vue";
import BaseButton from "@/components/buttons/BaseButton.vue";
import IconMoveDots from "@/components/icons/IconMoveDots";
export default {
  props: {
    orderType: { type: [String, Number], default: null },
    items: { type: Array, default: null },
    modal: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
  },
  components: {
    draggable,
    PopUp,
    BaseButton,
    IconMoveDots,
  },
  data() {
    return {
      orderedItems: [],
      changed: false,
    };
  },
  created() {
    this.orderedItems = JSON.parse(JSON.stringify(this.items));
    this.sortable(this.items);
  },
  watch: {
    modal(val) {
      this.sortable(this.items);
    },
  },
  methods: {
    changeOrder() {
      let orderedItems = [];
      orderedItems = this.orderedItems.map((el, id) => {
        return (el = { ...el, order: id });
      });
      this.orderedItems = orderedItems;
      this.changed = true;
    },
    sortable(items) {
      let type = this.orderType;
      let orderedItems = JSON.parse(JSON.stringify(items));
      orderedItems = orderedItems
        // .filter(el => {
        //   return el.orderType === type;
        // })
        .sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
      this.orderedItems = orderedItems;
    },
    hideModal() {
      if (this.changed) {
        this.$swal({
          html: "<h2>Are you sure you want to exit <br/> without saving?</h2>",
          showCancelButton: true,
          cancelButtonText: "Exit without saving",
          confirmButtonText: "Save changes",
        }).then(result => {
          if (result.value) {
            this.$emit("reorder", this.orderedItems);
          } else this.$emit("hideModal");
        });
      } else this.$emit("hideModal");
    },
  },
};
</script>
<style lang="scss" scoped>
.publications {
  height: 100%;
  padding: 0 15px;
  overflow-y: auto;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4rem;
    @media only screen and (max-width: $xs) {
      flex-direction: column;
      align-items: flex-start;
    }
    &_title {
      font-size: 3.35rem;
      font-weight: 600;
      line-height: 1.2;
      text-transform: capitalize;
      color: $black;
    }
    &_actions {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      @media only screen and (max-width: $xs) {
        justify-content: flex-start;
        width: 100%;
      }
      .button {
        margin-left: 10px;
        @media only screen and (max-width: $xs) {
          margin: 20px 10px 0 0;
        }
      }
    }
  }
  &__body {
    &_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 8rem;
      margin-bottom: 35px;
      border: 0.5px solid #bcbcbc;
      border-radius: 12px;
      padding: 0 27px;
      background: $white;
      cursor: pointer;
      p {
        @include type($fs: 14px, $fw: 600);
        color: $black;
      }
      &.sortable-chosen {
        background: rgba($color: $blueLight, $alpha: 0.5);
        color: $black;
      }
      &_svg {
        height: auto;
        width: auto;
      }
    }
  }
}
</style>
